import React, { Fragment, useMemo, useState, createRef, useEffect } from 'react';
import { map } from 'helpers';

export function Sections({ Background, children, ...props }) {
  const [ visible, setVisible ] = useState({ '0': true });
  const sections = useMemo(() => {
    return map(children, (Section, name) => ({ Section, name }))
      .map((item, index) => ({ ...item, index, breakpoint: createRef() }));
  }, []);

  useEffect(() => {
    const onIntersect = entries => entries.forEach(({ intersectionRatio, target }) =>
      setVisible(visible => ({
        ...visible,
        [target.getAttribute('data-index')]: intersectionRatio > 0,
        [target.getAttribute('data-name')]: intersectionRatio > 0,
      }))
    );
    const observer = new IntersectionObserver(onIntersect, { rootMargin: '99999% 0px -30% 0px', });
    sections.forEach(section => observer.observe(section.breakpoint.current));
    return () => observer.disconnect;
  }, []);

  return (
    <Fragment>
      { Background && <Background {...props} visible={visible} /> }
      { sections.map(({ Section, name, index, breakpoint }) =>
        <Fragment key={name}>
          <div ref={breakpoint} data-index={index} data-name={name} />
          <Section visible={!!visible[index]} scrolledPast={!!visible[index+1]} {...props} />
        </Fragment>
      ) }
    </Fragment>
  );
}
